import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import './fax.css';

const FaxPreview = ({ open, onClose, data }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
      overlayStyle={{ backgroundColor: 'transparent' }}
      scroll='paper'
      maxWidth='xl'
      fullWidth
    >
      <DialogTitle>Fax Preview</DialogTitle>
      <DialogContent>
        <div>
          <div className='fax-item'>
            <h6>Date</h6>
            <p>{data.date}</p>
          </div>
          <div className='fax-item'>
            <h6>Sender</h6>
            <p>{data.sender[0].name }</p>
          </div>
          <div className='fax-item'>
            <h6>From</h6>
            <p>{data.from}</p>
          </div>
          <div className='fax-item'>
            <h6>To</h6>
            <p>{data.to}</p>
          </div>
          <div className='fax-item'>
            <h6>Status</h6>
            <p>{data.status}</p>
          </div>
          <iframe src={data.file} type="application/pdf" className='col-sm-12' height={500} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FaxPreview;
